import uuid from "react-uuid";
import Rianxeria from "../../img/channels/latam-agents/riannxeira.jpg";
// import ZonaPago from "../../img/channels/latam-agents/zonapago.jpg";
import Farmacias911 from "../../img/channels/latam-agents/farmacias-911.jpg";
import WesternUnion from "../../img/channels/latam-agents/wu.jpg";
import Tia from "../../img/channels/latam-agents/tia.jpg";
import Medicity from "../../img/channels/latam-agents/medicity.jpg";
import MiComisariato from "../../img/channels/latam-agents/mi-comisariato.jpg";
// import InhouseCNT from "../../img/channels/latam-agents/cnt.jpg";
// import JardínAzuayo from "../../img/channels/latam-agents/azuayo.jpg";
import COAC29deOctubre from "../../img/channels/latam-agents/coac29.png";
// import COOPMEGO from "../../img/channels/latam-agents/coopmego.jpg";
import FarmaciasEconómicas from "../../img/channels/latam-agents/economicas.jpg";
// import Facilito from "../../img/channels/latam-agents/facilito.jpg";
import ERHipermarket from "../../img/channels/latam-agents/hiper-market.jpg";
// import MutualistaPichincha from "../../img/channels/latam-agents/matualista.jpg";
// import COAVMUCHUCRUNA from "../../img/channels/latam-agents/mushuc-runa.jpg";
import DIFCruzAzul from "../../img/channels/latam-agents/cruz-azul.jpg";
import BodegaAurrera from "../../img/channels/latam-agents/bodega-aurrera.jpg";
import SevenEleven from "../../img/channels/latam-agents/7-eleven.jpg";
import SamsClub from "../../img/channels/latam-agents/sams-club.jpg";
import Walmart from "../../img/channels/latam-agents/walmart.jpg";
import FarmaciasBarata from "../../img/channels/latam-agents/farmacias-barata.jpg";
import WalmartExpress from "../../img/channels/latam-agents/walmart-express.jpg";
import FarmaciasRoma from "../../img/channels/latam-agents/farmacias-roma.jpg";
import SuperdelNorte from "../../img/channels/latam-agents/super-norte.jpg";
// import SuperCity from "../../img/channels/latam-agents/super-city.jpg";
import Soriana from "../../img/channels/latam-agents/soriana.jpg";
import CCK from "../../img/channels/latam-agents/circle-k.jpg";
import Extra from "../../img/channels/latam-agents/extra.jpg";
import CityClub from "../../img/channels/latam-agents/city-club.jpg";
import Calimax from "../../img/channels/latam-agents/calimax.jpg";
import Santander from "../../img/channels/latam-agents/santander.png";
import BBVA from "../../img/channels/latam-agents/bbva.jpg";
import CajaCerano from "../../img/channels/latam-agents/caja-cerano.jpg";
import Banorte from "../../img/channels/latam-agents/banorte.jpg";
// import HSBC from "../../img/channels/latam-agents/hsbc.jpg";
import Kiosko from "../../img/channels/latam-agents/kiosko.jpg";
import CajaMorelia from "../../img/channels/latam-agents/caja-morelia.jpg";
import CajaOblatos from "../../img/channels/latam-agents/caja-oblatos.jpg";
import SBMRural from "../../img/channels/latam-agents/smb-rural.jpg";
import Telecom from "../../img/channels/latam-agents/telecom.jpg";
import Via from "../../img/channels/latam-agents/via.jpg";
// import Yza from "../../img/channels/latam-agents/yza.jpg";
import Afirme from "../../img/channels/latam-agents/afirme.jpg";
import Kasnet from "../../img/channels/latam-agents/kasnet.jpg";
import BCP from "../../img/channels/latam-agents/bcp.jpg";
import Izipay from "../../img/channels/latam-agents/izipay.png";
import Andes from "../../img/channels/latam-agents/andes.jpg";
import CajadelSanta from "../../img/channels/latam-agents/caja-santa.jpg";
import CajaPaita from "../../img/channels/latam-agents/caja-paita.jpg";
import Qapaq from "../../img/channels/latam-agents/qapaq.jpg";
import Raiz from "../../img/channels/latam-agents/raiz.jpg";
import CajaTrujillo from "../../img/channels/latam-agents/caja-trujillo.jpg";
import AgenteCash from "../../img/channels/latam-agents/agente-cash.jpg";
import Edypyme from "../../img/channels/latam-agents/edypyme.jpg";
import CajaSullana from "../../img/channels/latam-agents/caja-sullana.jpg";
import BancoNacional from "../../img/channels/latam-agents/banco-nacional.jpg";
import Payser from "../../img/channels/latam-agents/payser.jpg";
import Hey from "../../img/channels/latam-agents/hey.jpg";
import Bam from "../../img/channels/latam-agents/bam.jpg";
import Continental from "../../img/channels/latam-agents/continental.jpg";
import Machetazo from "../../img/channels/latam-agents/machetazo.jpg";
import Xtras from "../../img/channels/latam-agents/xtras.jpg";
// import Juan from "../../img/channels/latam-agents/juan.jpg";
import Servientrega from "../../img/channels/latam-agents/servientrega.png";
import Pharmacys from "../../img/channels/latam-agents/pharmacys.png";
import Pronet from "../../img/channels/latam-agents/pronet.png";
import JumboMarket from "../../img/channels/latam-agents/jumbo-market.jpg";
import FarmaExpress from "../../img/channels/latam-agents/farma-express.jpg";
import AmPm from "../../img/channels/latam-agents/am-pm.jpg";
import Yape from "../../img/channels/latam-agents/yape.png";
import Interbank from "../../img/channels/latam-agents/interbank.jpg";
import BancoPichincha from "../../img/channels/latam-agents/pichincha.jpg";
import Bancom from "../../img/channels/latam-agents/bancom.png";
import Megapunto from "../../img/channels/latam-agents/megapunto.png";

import RedDigital from "../../img/channels/latam-agents/red-digital.jpg";
import NiuBiz from "../../img/channels/latam-agents/niubiz.jpg";
import CajaArequipa from "../../img/channels/latam-agents/caja-arequipa.svg";
import Banbif from "../../img/channels/latam-agents/banbifwallet.png";
import TiendasEkono from "../../img/channels/latam-agents/tiendas-ekono.jpg";
import FarmaciasLaBomba from "../../img/channels/latam-agents/farmacias-la-bomba.jpg";
import FarmaciasFischel from "../../img/channels/latam-agents/farmacias-fischel.png";
import BancoPromerica from "../../img/channels/latam-agents/banco-promerica.png";
import BancoPopular from "../../img/channels/latam-agents/banco-popular.png";
import CajaTamazula from "../../img/channels/latam-agents/caja-tamazula.png";
import Systienda from "../../img/channels/latam-agents/systienda.png";
import Finabien from "../../img/channels/latam-agents/finabien.png";
import FarmaciasDelAhorro from "../../img/channels/latam-agents/farmacias-del-ahorro.png";
import Akisi from "../../img/channels/latam-agents/akisi.png";
import Super24 from "../../img/channels/latam-agents/super24.jpeg";
import PuntoPago from "../../img/channels/latam-agents/punto-pago.jpg";
import CoacErco from "../../img/channels/latam-agents/coac-erco.png";
import CoacMushuc from "../../img/channels/latam-agents/coac-mushuc.jpeg";
import CoacSanFrancisco from "../../img/channels/latam-agents/coac-san-francisco.png";
import CoacChibuleo from "../../img/channels/latam-agents/coac-chibuleo.png";
import CoacKullkiWasi from "../../img/channels/latam-agents/coac-kulllki-wasi.jpeg";
import Coac23 from "../../img/channels/latam-agents/coac23.png";
import MutualistaPichincha from "../../img/channels/latam-agents/mutualista-pichincha.jpeg";
import CoacPadreJulian from "../../img/channels/latam-agents/coac-padre-julian.png";
import Daquilema from "../../img/channels/latam-agents/daquilema.png";
import JardinAzuayo from "../../img/channels/latam-agents/jardin-azuayo.png";
import BancoInternacional from "../../img/channels/latam-agents/banco-internacional.png";
import MiNegocioEfectivo from "../../img/channels/latam-agents/mi-negocio-efectivo.jpeg";
import CirculoK from "../../img/channels/latam-agents/circle-k.jpg";
import SMBRural from "../../img/channels/latam-agents/smb-rural.jpg";

export const payCashChannels = {
  ECU: [
    {
      data: [
        {
          logo: BancoInternacional,
          name: "Banco Internacional",
          key: uuid(),
        },
        { logo: JardinAzuayo, name: "Jardin Azuayo", key: uuid() },
        { logo: Rianxeria, name: "Rianxeria", key: uuid() },
        // { logo: ZonaPago, name: "Zona Pago", key: uuid() },
        { logo: Farmacias911, name: "Farmacias 911", key: uuid() },
        { logo: WesternUnion, name: "Western Union", key: uuid() },
        { logo: Tia, name: "Tia", key: uuid() },
        { logo: Medicity, name: "Farmacias Medicity", key: uuid() },
        { logo: MiComisariato, name: "Mi Comisariato", key: uuid() },
        // { logo: InhouseCNT, name: "Inhouse CNT", key: uuid() },
        // { logo: JardínAzuayo, name: "Jardín Azuayo", key: uuid() },
        { logo: COAC29deOctubre, name: "COAC 29 de Octubre", key: uuid() },
        // { logo: COOPMEGO, name: "COOPMEGO", key: uuid() },
        {
          logo: FarmaciasEconómicas,
          name: "Farmacias Económicas",
          key: uuid(),
        },
        // { logo: Facilito, name: "Facilito", key: uuid() },
        { logo: ERHipermarket, name: "ER Hipermarket", key: uuid() },
        // {
        //   logo: MutualistaPichincha,
        //   name: "Mutualista Pichincha",
        //   key: uuid(),
        // },
        // { logo: COAVMUCHUCRUNA, name: "COAV MUCHUC RUNA", key: uuid() },
        { logo: DIFCruzAzul, name: "DIF Cruz Azul", key: uuid() },
        { logo: Servientrega, name: "Servientrega", key: uuid() },
        { logo: Pharmacys, name: "Pharmacy's", key: uuid() },
        { logo: CoacErco, name: "COAC ERCO LTDA", key: uuid() },
        { logo: CoacMushuc, name: "COAC MUSHUC RUNA", key: uuid() },
        { logo: CoacSanFrancisco, name: "COAC SAN FRANCISCO", key: uuid() },
        { logo: CoacChibuleo, name: "COAC CHIBULEO", key: uuid() },
        { logo: CoacKullkiWasi, name: "COAC KULLKI WASI", key: uuid() },
        { logo: Coac23, name: "COAC 23 DE JULIO LTDA", key: uuid() },
        {
          logo: MutualistaPichincha,
          name: "Mutualista Pichincha",
          key: uuid(),
        },
        { logo: CoacPadreJulian, name: "Padre Julian Lorente", key: uuid() },
        { logo: Daquilema, name: "Daquilema", key: uuid() },
        { logo: MiNegocioEfectivo, name: "Mi Negocio Efectivo", key: uuid() },
      ],
      key: uuid(),
    },
  ],
  MEX: [
    {
      data: [
        { logo: Santander, name: "Santander", key: uuid() },
        { logo: BBVA, name: "BBVA", key: uuid() },
        { logo: Banorte, name: "Banorte", key: uuid() },
        { logo: Afirme, name: "Banco AFIRME", key: uuid() },
        { logo: BodegaAurrera, name: "Bodega Aurrera", key: uuid() },
        { logo: SevenEleven, name: "7-Eleven", key: uuid() },
        { logo: SamsClub, name: "Sam's Club", key: uuid() },
        { logo: Walmart, name: "Walmart", key: uuid() },
        {
          logo: FarmaciasBarata,
          name: "Farmacias la más Barata",
          key: uuid(),
        },
        { logo: FarmaciasRoma, name: "Farmacia Roma", key: uuid() },
        {
          logo: FarmaciasDelAhorro,
          name: "Farmacias Del Ahorro",
          key: uuid(),
        },
        {
          logo: WalmartExpress,
          name: "Walmart Express",
          key: uuid(),
        },
        { logo: SuperdelNorte, name: "Super del Norte", key: uuid() },
        // { logo: SuperCity, name: "Super City", key: uuid() },
        { logo: Soriana, name: "Soriana", key: uuid() },
        { logo: CirculoK, name: "Circulo K", key: uuid() },
        { logo: Extra, name: "Extra", key: uuid() },
        { logo: CityClub, name: "City Club", key: uuid() },
        { logo: Calimax, name: "Calimax", key: uuid() },
        { logo: CajaCerano, name: "Caja Cerano", key: uuid() },
        // { logo: HSBC, name: "HSBC", key: uuid() },
        { logo: Kiosko, name: "Kiosko", key: uuid() },
        { logo: CajaMorelia, name: "Caja Morelia", key: uuid() },
        { logo: CajaOblatos, name: "Caja Oblatos", key: uuid() },
        { logo: SMBRural, name: "SMB Rural", key: uuid() },
        { logo: Telecom, name: "Telecom", key: uuid() },
        { logo: Via, name: "Via de Servicios", key: uuid() },
        { logo: CajaTamazula, name: "Caja Tamazula", key: uuid() },
        { logo: Systienda, name: "Systienda", key: uuid() },
        { logo: Finabien, name: "Finabien", key: uuid() },
        // { logo: Yza, name: "Yza + Farmacias", key: uuid() },
      ],
      key: uuid(),
    },
  ],
  PER: [
    {
      data: [
        { logo: BBVA, name: "BBVA", key: uuid() },
        { logo: BCP, name: "Banco BCP", key: uuid() },
        { logo: Interbank, name: "Interbank", key: uuid() },
        { logo: BancoPichincha, name: "Banco Pichincha", key: uuid() },
        { logo: Bancom, name: "Banco del Comercio", key: uuid() },
        { logo: Kasnet, name: "Kasnet", key: uuid() },
        { logo: WesternUnion, name: "Western Union", key: uuid() },
        { logo: Izipay, name: "Izipay", key: uuid() },
        { logo: Banbif, name: "Banbif", key: uuid() },
        { logo: Andes, name: "Caja Los Andes", key: uuid() },
        { logo: CajadelSanta, name: "Caja del Santa", key: uuid() },
        { logo: CajaPaita, name: "Caja Paita", key: uuid() },
        { logo: Qapaq, name: "Financiera Qapaq", key: uuid() },
        // { logo: Raiz, name: "Crac - Raiz", key: uuid() },
        { logo: CajaTrujillo, name: "Caja Trujillo", key: uuid() },
        { logo: AgenteCash, name: "Agente Cash", key: uuid() },
        { logo: Edypyme, name: "Edypyme Alternativa", key: uuid() },
        // { logo: CajaSullana, name: "Caja Sullana", key: uuid() },
        { logo: Yape, name: "Yape", key: uuid() },
        { logo: Megapunto, name: "Megapunto", key: uuid() },
        { logo: RedDigital, name: "Red Digital", key: uuid() },
        { logo: NiuBiz, name: "Niubiz", key: uuid() },
        { logo: CajaArequipa, name: "Caja Arequipa", key: uuid() },
      ],
      key: uuid(),
    },
  ],
  CRI: [
    {
      data: [
        { logo: BancoNacional, name: "Banco Nacional", key: uuid() },
        { logo: BancoPromerica, name: "Banco Promerica", key: uuid() },
        { logo: BancoPopular, name: "Banco Popular", key: uuid() },
        { logo: Payser, name: "Payser", key: uuid() },
        { logo: Hey, name: "Puntos Hey", key: uuid() },
        { logo: TiendasEkono, name: "Tiendas Ekono", key: uuid() },
        { logo: FarmaciasFischel, name: "Farmacias Fischel", key: uuid() },
        { logo: FarmaciasLaBomba, name: "Farmacias La Bomba", key: uuid() },
      ],
      key: uuid(),
    },
  ],
  GTM: [
    {
      data: [
        // { logo: Bam, name: "Banco Agromercantil", key: uuid() },
        // {
        //   logo: Continental,
        //   name: "Banco G&T Continental",
        //   key: uuid(),
        // },
        { logo: Akisi, name: "AKISI", key: uuid() },
        { logo: Pronet, name: "Pronet", key: uuid() },
        // { logo: Super24, name: "Super 24", key: uuid() },
      ],
      key: uuid(),
    },
  ],
  PAN: [
    {
      data: [
        // { logo: WesternUnion, name: "Western Union", key: uuid() },
        // { logo: Machetazo, name: "El Machetazo", key: uuid() },
        // { logo: Xtras, name: "Super Xtras", key: uuid() },
        // { logo: Juan, name: "Juan XXIII", key: uuid() },
        // { logo: JumboMarket, name: "Jumbo Market", key: uuid() },
        // { logo: FarmaExpress, name: "Farma Express", key: uuid() },
        // { logo: AmPm, name: "am:pm", key: uuid() },
        { logo: PuntoPago, name: "Punto Pago", key: uuid() },
      ],
      key: uuid(),
    },
  ],
};
